import { Pipe, PipeTransform } from '@angular/core';
import { getReadableTextOnWhite } from 'src/app/utils/utils.function';

/**
 * Text-on-WHITE contrast for status labels — the counterpart to
 * `statusTextColor` (which solves the opposite case: text drawn ON the
 * status colour). The status-change dropdown lists (`.detail-status-dropdown`
 * / `.btn_status_container`) render a white pill with the raw status colour
 * painted straight onto the label, so a pale status colour (e.g. a light
 * yellow "BID SENT") becomes near-invisible light-on-white. This darkens the
 * colour just enough to clear WCAG AA contrast against white while keeping
 * its hue; already-readable colours pass through unchanged.
 */
@Pipe({
    name: 'readableTextOnWhite',
    standalone: false
})
export class ReadableTextOnWhitePipe implements PipeTransform {
  transform(statusColor: string | undefined | null): string {
    return getReadableTextOnWhite(statusColor || '');
  }
}
